module.exports = __webpack_public_path__ + "static/img/10.69a3426.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/10.jpg
// module id = Y/jY
// module chunks = 0